var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "box",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.76,
    height: 38.952,
    viewBox: "0 0 44.328 48.952",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_106",
    d: "M18.839.889a6.649,6.649,0,0,1,6.649,0h0L41,9.755a6.649,6.649,0,0,1,2.072,1.875,2.259,2.259,0,0,1,.355.463,2.216,2.216,0,0,1,.2.443,6.678,6.678,0,0,1,.7,2.981h0V33.248A6.649,6.649,0,0,1,41,39.011h0L25.489,47.877a6.649,6.649,0,0,1-2.276.809,2.216,2.216,0,0,1-2.1,0,6.621,6.621,0,0,1-2.274-.809h0L3.325,39.011A6.649,6.649,0,0,1,0,33.248H0V15.517A6.649,6.649,0,0,1,.7,12.56a2.234,2.234,0,0,1,.556-.922A6.62,6.62,0,0,1,3.325,9.755h0ZM4.433,16.707V33.248a2.216,2.216,0,0,0,1.108,1.913h0L19.948,43.4V25.682Zm35.463,0L24.38,25.682V43.393l14.407-8.23a2.216,2.216,0,0,0,1.093-1.656l.016-.259ZM23.272,4.739a2.216,2.216,0,0,0-2.216,0h0L6.736,12.92l15.428,8.923L37.59,12.92Z",
    transform: "translate(0 0.002)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.761622629297f377c9d380978dec69cc.svg";
export { ForwardRef as ReactComponent };